import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import LinkButton from 'flarum/common/components/LinkButton';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import CampaignPage from './components/CampaignPage';
import {
  clearReferral,
  isReferralValidationError,
  loadReferral,
} from './referralStorage.mjs';

app.initializers.add('dzpbw-referral-campaigns', () => {
  if (app.data.session.userId) {
    clearReferral(window.localStorage);
  }

  app.routes['dzpbw-referral-campaign'] = {
    path: '/events/:slug',
    component: CampaignPage,
  };

  extend(HeaderPrimary.prototype, 'items', (items) => {
    const campaign = app.forum.attribute('dzpbwReferralCampaign');

    if (!campaign) return;

    items.add(
      'dzpbw-referral-campaign',
      <LinkButton
        className="Button Button--link ReferralCampaign-nav"
        icon="fas fa-gift"
        href={app.route('dzpbw-referral-campaign', { slug: campaign.slug })}
      >
        {campaign.title}
      </LinkButton>,
      25
    );
  });

  extend(SignUpModal.prototype, 'submitData', function (data) {
    const stored = this.dzpbwReferral || loadReferral(window.localStorage);

    if (!stored) return;

    this.dzpbwReferral = stored;
    data.referralCode = stored.code;
  });

  extend(SignUpModal.prototype, 'onerror', function (error) {
    if (!isReferralValidationError(error)) return;

    clearReferral(window.localStorage);
    this.dzpbwReferral = null;
  });
});
